var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1VirtualReality(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7 44.42h-2.53L52.57 50s-.08.19-.11.28c-.03.09-1.71 5.86-5.14 5.86h-.78c-5.15 0-2.82 5.18-1.71 6.77H21.35c10.07-9.54 1.57-15.84-1-20.87-2-3.85-2.8-5.67-3.08-8H35v3h21.36a.445.445 0 010 .08s2.45 5.54 2.48 5.7a1.42 1.42 0 01-1.14 1.6zM38 34h20.44v-9H38v3H14.31a1.5 1.5 0 000 3H38v3zm-3-12h18c-1-2.58-6.91-9.06-17.19-9.06-8.81 0-16.1 8.5-17.45 12.06H35v-3z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Virtual_reality.6a8245ed.svg";
export { SvgK1VirtualReality as ReactComponent };